import { Layout } from "antd";
import React from "react";
import ControlPanel from "./ControlPanel";
const PremierPlusDashboard = () => {

    return (
        <Layout.Content className="dashboard">
            <ControlPanel />
        </Layout.Content>
    );
};

export default PremierPlusDashboard;
